module.exports = __webpack_public_path__ + "static/media/classic_car.6bc78a01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/classic_car.svg
// module id = 337
// module chunks = 0